import {createSelector, createStructuredSelector} from 'reselect';
import * as _ from 'lodash';
import {
  getUpdatedVariations,
  hasVariations,
  isDirty,
  isNonDraft,
  prepareVariationSpecificsSetForEditDialog,
} from '../../../MyAccount/Listings/EbayListing/ebayListingSelectors';
import {createDeepEqualSelector} from '../ActionsManagerSelectors';
import {getListingsPageListings, getSelectedSellerId} from '../../selectors/listingsPageSelectors';
import {STATUS_FILTERS} from '../../../MyAccount/Listings/consts';
import {EbayListing} from 'cl-api';
import {Map} from 'immutable';
import {EbayListingsActionsProps} from './EbayListingsActionsConsts';
import {getUnusedVariations} from '../VariationsActions/VariationsActionsHelpers';
import {EBAY_LISTINGS_ACTIONS_TYPES} from '../ActionsTypes';
import {StoreState} from '../../../App/initialStore';
import {getFormValues} from 'redux-form';
import {selectedCount} from 'cl-table/redux/actions';
import {VARIATIONS_TABLE} from '../../../MyAccount/Listings/EbayListing/VariationsSection';

const getListingsIds = (state, props: EbayListingsActionsProps) => props.listingsIds;

export const getIsDirtyStoreProps = createStructuredSelector({
  dirty: isDirty,
});

export const ebayListingsActionsMapStateToProps = createDeepEqualSelector(
  [getListingsPageListings, getSelectedSellerId, getListingsIds],
  (listings, selectedSellerId: string, listingsIds) => {
    const objects = _.filter(
      _.map(
        listingsIds,
        itemId =>
          _.transform(
            listings[selectedSellerId],
            (accumulator: {found: EbayListing}, value: {listings: Map<string, EbayListing>}, key: string) => {
              if (_.includes(STATUS_FILTERS, key)) {
                accumulator.found = value.listings.get(itemId);
                if (accumulator.found) {
                  return false;
                }
              }
            }
          ).found
      )
    );
    return {objects};
  }
);

export const getUnusedListingVariations = createSelector(
  [getUpdatedVariations, prepareVariationSpecificsSetForEditDialog],
  (currentVariations, variationsSpecificSet) => {
    return getUnusedVariations(currentVariations, variationsSpecificSet);
  }
);

export const hasVariationsToAddDialogStoreProps = createSelector(
  [getUnusedListingVariations],
  variationsSpecificSetForAddDialog => {
    return {hasVariationsToAdd: !_.isEmpty(variationsSpecificSetForAddDialog)};
  }
);

export const hasVariationsStoreProps = createSelector(
  [hasVariations],
  hasVariations => {
    return {hasVariations: hasVariations};
  }
);

const getEditVariationsDialogFormValues = (state: StoreState) => {
  return getFormValues(EBAY_LISTINGS_ACTIONS_TYPES.EDIT_VARIATION_OPTIONS)(state);
};

export const getEditVariationsDialogStoreProps = createSelector(
  [isNonDraft, getEditVariationsDialogFormValues],
  (nonDraft, editVariationsDialogFormValues) => {
    return {
      emptyEditVariationsForm: _.isEmpty(_.filter(editVariationsDialogFormValues, value => !_.isEmpty(value))),
      nonDraft: nonDraft,
    };
  }
);

const getVariationsTableCount = state => state.table[VARIATIONS_TABLE].count;
const getVariationsTableSelection = state => state.table[VARIATIONS_TABLE].selection;

export const getReduxTableStoreProps = createSelector(
  [isNonDraft, getVariationsTableCount, getVariationsTableSelection],
  (nonDraft, count, selection) => {
    const countSelected = count && selection ? selectedCount({count, selection}) : undefined;
    return {
      allVariationsSelected: count === countSelected,
      nonDraft: nonDraft,
    };
  }
);
